import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3fccfc7c&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=3fccfc7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fccfc7c",
  null
  
)

export default component.exports